import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { EventsService } from '../../../../../services/events.service';
import { GeneralService } from '../../../../../services/general.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ShowPlaceComponent } from './show-place/show-place.component';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-step-places',
  templateUrl: './step-places.component.html',
  styleUrls: ['./step-places.component.scss']
})
export class StepPlacesComponent implements OnInit, OnDestroy {
  user;
  show:number=0;
  radio;
  hide=true;//true
  element;

  priceSelect=0;
  countrySelect="";
  capacitySelect=0;

  primaryContact={primary:false,id: 1, name: 'Hydrogen'};
  own=[];
  rent=[];
  dataSourceOwn;
  dataSourceRent;
  displayedColumnsOwn: string[] = ['name', 'category', 'capacity','ubication','visibility'];
  displayedColumnsRent: string[] = ['name', 'category', 'capacity','ubication','visibility'];

  capacity = [
    {value: '0', viewValue: 'No importa'},
    {value: '50', viewValue: '50'},
    {value: '100', viewValue: '100'},
    {value: '200', viewValue: '200'},
    {value: '500', viewValue: '500'},
    {value: '501', viewValue: '> 500'},
  ];

  price = [
    {value: '0', viewValue: 'No importa'},
    {value: '25', viewValue: '25'},
    {value: '50', viewValue: '50'},
    {value: '75', viewValue: '75'},
    {value: '100', viewValue: '100'},
    {value: '150', viewValue: '150'},
    {value: '151', viewValue: '> 150'},
  ];

  country = [];

  msg;
  typeMsg;
  msgSuscription: Subscription;
  typeMsgSuscription: Subscription;
  @Output() nextStep: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild("paginatorOwn", {static: true}) paginatorOwn: MatPaginator;
  @ViewChild("paginatorRent", {static: true}) paginatorRent: MatPaginator;

  @Input() createPage=false;

  constructor(private EventsService: EventsService,
    private GeneralService: GeneralService,
    public dialog: MatDialog) { }


  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem("userData"));
    console.log("places :this.user on step-place:", this.user);
    this.msgSuscription = this.GeneralService.msg$.subscribe(data => {
      this.msg = data;
    });

    this.typeMsgSuscription = this.GeneralService.typeMsg$.subscribe(data => {
      this.typeMsg = data;
    });

    this.EventsService.get_places_availables(this.user.id).subscribe(res => {
      console.log("res:places get_places_availables:", res);
      if(!res.message_return.ERROR){
        this.own=res.owns; this.rent=res.rents;
        this.dataSourceOwn = new MatTableDataSource(res.owns);
        this.dataSourceOwn.paginator = this.paginatorOwn;
        this.dataSourceRent = new MatTableDataSource(res.rents);
        this.dataSourceRent.paginator = this.paginatorRent;
      }else{
        this.GeneralService.typeMsg$.emit("error");
        this.GeneralService.msg$.emit(res.message_return.ERROR_MENSAGGE+"get_places_availables");
      }
    }, err => {
      console.log("ERRor get_places_availables", err);
      this.GeneralService.typeMsg$.emit("error");
      this.GeneralService.msg$.emit(err.statusText);
    });

    this.GeneralService.get_countries().subscribe(res => {
      console.log("res:places teacher-get_countries:", res);
      if(!res.message_return.ERROR){
        res.countries.forEach(element => {
          this.country.push({
            name:element.nicename,
            id:element.id
          });
        });
      }else{
        this.GeneralService.typeMsg$.emit("error");
        this.GeneralService.msg$.emit(res.message_return.ERROR_MENSAGGE+"teacher");
      }
    }, err => {
      console.log("ERRor get_countries", err);
      this.GeneralService.typeMsg$.emit("error");
      this.GeneralService.msg$.emit(err.statusText);
    });


  }

  applyFilterOwn(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceOwn.filter = filterValue.trim().toLowerCase();
  }

  applyFilterRent(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceRent.filter = filterValue.trim().toLowerCase();
  }

  primaryClick(element){
    this.primaryContact=element;
    this.EventsService.place$.emit(element);
  }

  openDialogOwn(element) {
    const dialogRef = this.dialog.open(ShowPlaceComponent, {
      height: '650px',
      width: '1000px',
      // width: 'auto',
      data: {element, showRent: false, course: false}
    });
    const sub = dialogRef.componentInstance.goToStep3.subscribe(() => {
      console.log("probando ir al paos 3");
      this.nextStepper();
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  nextStepper(){
    this.nextStep.emit(true);
  }


  openDialogRent(element) {
    const dialogRef = this.dialog.open(ShowPlaceComponent, {
      height: '650px',
      width: '1000px',
      // width: 'auto',
      data: {element, showRent: true,  course: false}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  ngOnDestroy(){
    this.msgSuscription;
    this.typeMsgSuscription
  }

}
